export default __webpack_public_path__ + "static/media/github-edit-file.28c98149.png";